module.exports = __webpack_public_path__ + "img/手机长图2.24104083.png";